//import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Message from '../components/Message';
import { Link, useNavigate } from 'react-router-dom';
import {
  Row,
  Col,
  ListGroup,
  Image,
  Form,
  Button,
} from 'react-bootstrap';
import { addToCart, removeFromCart } from '../slices/cartSlice';
import { FaTrash } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { Helmet } from '@slorber/react-helmet-async';
import { getImageUrl } from '../utils/imageUtils'; // ✅ Import de l'utilitaire

const CartScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  //selim
  const { deviseInfo } = useSelector((state) => state.devise);

  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;

  const addToCartHandler = async (product, qty) => {
    dispatch(addToCart({ ...product, qty }));
  };

  const removeFromCartHandler = async (id) => {
    dispatch(removeFromCart(id));
  };

  const checkoutHandler = () => {
    //navigate('/login?redirect=/shipping');
    navigate('/shipping');
  };

  return (
    <Row>
      <Col md={8}>
        <div className='cart-shell'>
        <div className='page-heading text-start'>
          <h1 style={{ textAlign: 'left' }}>{t('cart')}</h1>
        </div>
        {cartItems.length === 0 ? (
          <Message>
            {t('emptycart')} <Link to='/'>{t('return')}</Link>
          </Message>
        ) : (
          <ListGroup variant='flush'>
            {cartItems.map((item) => (
              <ListGroup.Item key={item._id}>
                <Row className='align-items-center g-3'>
                  <Col md={2}>
                    {/* ✅ CORRECTION : Utiliser getImageUrl pour l'image du panier */}
                    <Image 
                      src={getImageUrl(item.image)} 
                      alt={item.name} 
                      fluid 
                      rounded 
                      onError={(e) => {
                        e.target.src = '/images/placeholder.jpg';
                      }}
                    />
                  </Col>
                  <Col md={3}>
                  <strong>
                    {item.name}
                  </strong>
                    {/* <Link to={`/product/${item._id}`}>{item.name}</Link> */}
                  </Col>
                  {/* selim */}
                  {/* <Col md={2}>
                    ${item.price}
                  </Col> */}
                  {deviseInfo === 'TND' && (
                    <Col>
                      <strong>
                        {item.price} {deviseInfo}
                      </strong>
                    </Col>
                  )}
                  {deviseInfo === 'EUR' && (
                    <Col>
                      <strong>
                        {item.priceEur} {deviseInfo}
                      </strong>
                    </Col>
                  )}
                  {deviseInfo === 'USD' && (
                    <Col>
                      <strong>
                        {item.priceDol} {deviseInfo}
                      </strong>
                    </Col>
                  )}

                  <Col md={2}>
                    <Form.Control
                      as='select'
                      value={item.qty}
                      onChange={(e) =>
                        addToCartHandler(item, Number(e.target.value))
                      }
                    >
                      {[...Array(item.countInStock).keys()].map((x) => (
                        <option key={x + 1} value={x + 1}>
                          {x + 1}
                        </option>
                      ))}
                    </Form.Control>
                  </Col>
                  <Col md={2}>
                    <Button
                      type='button'
                      variant='outline-danger'
                      className='rounded-pill'
                      onClick={() => removeFromCartHandler(item._id)}
                    >
                      <FaTrash />
                    </Button>
                  </Col>
                </Row>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
        </div>
      </Col>

      <Col md={4}>
        <div className='cart-summary'>
          <ListGroup variant='flush'>
            <ListGroup.Item className='bg-transparent border-0'>
              <h2>
                {t('total')} (
                {cartItems.reduce((acc, item) => acc + item.qty, 0)})
                {t('article')}
              </h2>
              {/* selim */}
              {/* Prix : { cartItems
                          .reduce((acc, item) => acc + item.qty * item.price, 0)
                          .toFixed(2)} */}
              {deviseInfo === 'TND' && (
                <h4>
                  Total :{' '}
                  {cartItems
                    .reduce((acc, item) => acc + item.qty * item.price, 0)
                    .toFixed(2)}{' '}
                  {deviseInfo}
                </h4>
              )}
              {deviseInfo === 'EUR' && (
                <h4>
                  Total :{' '}
                  {cartItems
                    .reduce((acc, item) => acc + item.qty * item.priceEur, 0)
                    .toFixed(2)}{' '}
                  {deviseInfo}
                </h4>
              )}
              {deviseInfo === 'USD' && (
                <h4>
                  Total :{' '}
                  {cartItems
                    .reduce((acc, item) => acc + item.qty * item.priceDol, 0)
                    .toFixed(2)}{' '}
                  {deviseInfo}
                </h4>
              )}
            </ListGroup.Item>
            <ListGroup.Item className='bg-transparent border-0'>
              <Button
                type='button'
                className='btn-teal w-100'
                disabled={cartItems.length === 0}
                onClick={checkoutHandler}
              >
                {t('proceedcheckout')}
              </Button>
            </ListGroup.Item>
          </ListGroup>
        </div>
      </Col>
      <Helmet>
        <title> Licorne Professional Academy - Panier </title>
        <meta
          name='description'
          content='Licorne Professional Academy - Panier'
        />
        <link rel='canonical' href='https://fr.licorne-academy.com/cart' />
      </Helmet>
    </Row>
  );
};

export default CartScreen;